import React from 'react'

const TdFixed = ({children, colSpan, rowSpan, className, textRight}) => {
  return (
    <td 
      colSpan={colSpan}
      rowSpan={rowSpan}
      className={`p-1 px-2 text-center align-middle ${textRight && 'text-right'} ${className}`}
      style={{
        fontSize: '14px'
      }}
    >
      {children}
    </td>
  )
}

export default TdFixed
